import { render, staticRenderFns } from "./PackagePreviewCard.vue?vue&type=template&id=39748c10"
import script from "./PackagePreviewCard.vue?vue&type=script&lang=js"
export * from "./PackagePreviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports